import React from "react";
import HRHeader from "../components/HRHeader";
import { Stamp } from "lucide-react";
import { LetterheadTab } from "./admin/LetterheadTab";

const CartaIntestataPage = () => {
  return (
    <div className="min-h-screen bg-[#f0f2f5]">
      <HRHeader />
      <main className="max-w-[1000px] mx-auto px-4 py-8" data-testid="carta-intestata-page">
        <div className="mb-6">
          <h1 className="text-[26px] font-black text-[#16345c] mb-1 flex items-center gap-2">
            <Stamp size={24} /> Carta Intestata Attestati
          </h1>
          <p className="text-[14px] text-gray-500">
            Gestisci l'intestazione grafica usata negli attestati di servizio PDF, con una immagine diversa per ciascuna società.
          </p>
        </div>
        <LetterheadTab />
      </main>
    </div>
  );
};

export default CartaIntestataPage;
